import { MultiSelect, MultiSelectPanelHeaderTemplateParams, MultiSelectProps } from 'primereact/multiselect'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

interface LocationMultiSelectProps {
  selectProps: MultiSelectProps
  wrapperId: string
  width?: string | undefined
}

export default function LocationMultiselect({ selectProps, wrapperId, width = undefined }: LocationMultiSelectProps) {
  const { t } = useTranslation()
  const hasOptions = !!selectProps?.options?.length

  function panelHeaderTemplate(options: MultiSelectPanelHeaderTemplateParams) {
    return (
      <>
        {hasOptions ? (
          <div className="p-multiselect-header">
            <>
              <label className="d-flex align-items-center">
                {options.checkboxElement}
                <span role="button" className="px-2 user-select-none">
                  {t('buttons.choose-all')}
                </span>
              </label>
              {options.filterElement}
              {options.closeElement}
            </>
          </div>
        ) : (
          <div className="d-flex h-full w-full pt-3 justify-content-center align-items-center fw-semibold">
            {t('most-used-words.location-not-found')}
          </div>
        )}
      </>
    )
  }

  return (
    <MultiSelectWrapper id={wrapperId}>
      <label className="autocomplete-title">{t('most-used-words.location')}</label>
      <i className="autocomplete-icon p-input-icon-left pi pi-map-marker"></i>
      <StyledMultiSelect
        {...selectProps}
        width={width}
        fixedPlaceholder={!hasOptions}
        panelHeaderTemplate={panelHeaderTemplate}
      />
    </MultiSelectWrapper>
  )
}

const MultiSelectWrapper = styled.div`
  position: relative;
  .autocomplete-title {
    position: absolute;
    left: 35px;
  }
  .autocomplete-icon {
    position: absolute;
    left: 8px;
    top: 16px;
    z-index: 1;
    color: #a8a8a8;
  }

  .p-multiselect .p-multiselect-label {
    font-size: 14px;
    font-weight: 600;
    margin-top: 0.6rem;
    margin-left: 0.05rem;
    padding-left: 35px;
    padding-right: 0;
  }
`
const StyledMultiSelect = styled(MultiSelect)`
  width: ${({ width }: { width: string | undefined }) => width ?? '400px'};
  height: 50px;
  border-radius: 10px;
  align-items: center;
  text-align: left;

  @media (max-width: 1400px) {
    ${({ width }: { width: string | undefined }) => width && { 'max-width': '14.5rem;' }};
  }

  @media (max-width: 1200px) {
   max-width: ${({ width }: { width: string | undefined }) => (width ? '12rem' : '16.5rem')}};
  }
`
